/**
 * Message for a refused upload in the classic screens (the new design uses v2/lib/api useErrorText).
 * The server answers with `{status:false, error:{message_code, message, details}}`: too large (413),
 * unsupported type (415), empty file, or a request that can no longer be edited (409).
 */
import { translateErrorCode } from "../contexts/LanguageContext";
import { MAX_UPLOAD_MB } from "./uploadPolicy";

export function uploadErrorMessage(status: number, body: any, fallback = "Failed to upload document"): string {
  const err = body && typeof body === "object" ? body.error : null;
  const code: string | undefined = err && typeof err === "object" ? err.message_code : undefined;
  const localized = translateErrorCode(code, err?.details || null);
  if (localized) return localized;
  if (status === 413) return translateErrorCode("attachment.file_too_large", { max_size_mb: MAX_UPLOAD_MB }) || fallback;
  if (status === 415) return translateErrorCode("attachment.unsupported_file_type") || fallback;
  if (err && typeof err === "object" && typeof err.message === "string") return err.message;
  if (body && typeof body.detail === "string") return body.detail;
  if (body && typeof body.message === "string") return body.message;
  return fallback;
}

/** Same as uploadErrorMessage for a raw response text (XHR). */
export function uploadErrorMessageFromText(status: number, text: string, fallback?: string): string {
  let body: any = null;
  try {
    body = text ? JSON.parse(text) : null;
  } catch {
    body = null;
  }
  return uploadErrorMessage(status, body, fallback || `Upload failed (${status})`);
}
